import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeedNoItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 187,
	height: 121,
	viewBox: "0 0 187 121",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 60.6072,
			cy: 60.5471,
			r: 58.5471,
			stroke: "#BF27F5",
			strokeWidth: 3.27148
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 93.5,
			cy: 60.5471,
			r: 58.5471,
			stroke: "#BF27F5",
			strokeOpacity: .55,
			strokeWidth: 3.27148
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 126.393,
			cy: 60.5471,
			r: 58.5471,
			stroke: "#BF27F5",
			strokeOpacity: .25,
			strokeWidth: 3.27148
		})
	]
});
export default SvgFeedNoItem;
